import { OneWayInServiceUpsertDto } from 'src/api/v2';
import useServiceSubForm, { extractSubData, SubFormProps, SubFormReturn } from '../use-service-sub-form';
import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { EEA_COMMENTS_MAX_LENGTH } from '../../constants/service-form-max-lengths';

export type EeaFields = 'selectedEeaArticles' | 'eeaComments';
export type EeaData = Pick<OneWayInServiceUpsertDto, EeaFields>;

type UseEeaFormProps = SubFormProps<EeaData> & {
  eeaCommentsRawTextRef?: MutableRefObject<string>;
};

const useEeaForm = ({
  data,
  updateData,
  errors,
  setErrors,
  eeaCommentsRawTextRef,
}: UseEeaFormProps): SubFormReturn<EeaData, EeaFields> => {
  const { t } = useTranslation('services');
  const rules: Partial<Record<keyof OneWayInServiceUpsertDto, any>> = {
    eeaComments: {
      validate: (value) => {
        const textLength = eeaCommentsRawTextRef?.current
          ? eeaCommentsRawTextRef.current.length
          : (() => {
              const div = document.createElement('div');
              div.innerHTML = value || '';
              return (div.textContent || '').length;
            })();
        if (textLength > EEA_COMMENTS_MAX_LENGTH) {
          return t('eea.comments.maxLength');
        }
        return true;
      },
    },
  };

  const extractEeaFields = (data: OneWayInServiceUpsertDto): EeaData => {
    return extractSubData(data, ['selectedEeaArticles', 'eeaComments']);
  };
  const eeaFields = extractEeaFields(data);
  const { form } = useServiceSubForm<EeaData>(eeaFields, updateData, errors, setErrors);
  const registerWithRules = (field: EeaFields) => form.register(field, rules[field]);
  return { form, rules, registerWithRules };
};

export default useEeaForm;
